import type { SVGProps } from "react";

export type IconProps = SVGProps<SVGSVGElement> & { size?: number | string };

function base({ size = "1em", ...rest }: IconProps): SVGProps<SVGSVGElement> {
  return {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
    focusable: false,
    ...rest,
  };
}

export const IconCheck = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M3.5 8.5l3 3 6-7" />
  </svg>
);
export const IconMinus = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M4 8h8" />
  </svg>
);
export const IconChevronRight = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M6 3.5L10.5 8 6 12.5" />
  </svg>
);
export const IconChevronDown = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M3.5 6L8 10.5 12.5 6" />
  </svg>
);
export const IconClose = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M4 4l8 8M12 4l-8 8" />
  </svg>
);
export const IconCopy = (p: IconProps) => (
  <svg {...base(p)}>
    <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" />
    <path d="M10.5 3.5v-.5a1 1 0 00-1-1h-6a1 1 0 00-1 1v6a1 1 0 001 1h.5" />
  </svg>
);
export const IconInfo = (p: IconProps) => (
  <svg {...base(p)}>
    <circle cx="8" cy="8" r="6.25" />
    <path d="M8 7.25V11M8 5h.01" />
  </svg>
);
export const IconWarning = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M8 2.25L14.25 13H1.75L8 2.25z" />
    <path d="M8 6.5v3M8 11.25h.01" />
  </svg>
);
export const IconSuccess = (p: IconProps) => (
  <svg {...base(p)}>
    <circle cx="8" cy="8" r="6.25" />
    <path d="M5.25 8.25l2 2 3.5-4" />
  </svg>
);
export const IconError = (p: IconProps) => (
  <svg {...base(p)}>
    <circle cx="8" cy="8" r="6.25" />
    <path d="M6 6l4 4M10 6l-4 4" />
  </svg>
);
export const IconReset = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M2 8a6 6 0 1 0 6-6 6.5 6.5 0 0 0-4.5 1.83L2 5.33" />
    <path d="M2 2v3.33h3.33" />
  </svg>
);
export const IconSearch = (p: IconProps) => (
  <svg {...base(p)}>
    <circle cx="7" cy="7" r="4.25" />
    <path d="M10.25 10.25L13.5 13.5" />
  </svg>
);
